import { forwardRef, type Ref } from 'react';
import { Icon, type IconVariant } from '@hungryroot/icons';
import {
  IconButton as RamenIconButton,
  type IconButtonProps,
} from '@hungryroot/ramen';

type Props = IconButtonProps & {
  icon: IconVariant;
};

export const IconButton = forwardRef(
  (props: Props, ref: Ref<HTMLButtonElement | HTMLAnchorElement>) => {
    const { icon } = props;

    return (
      <RamenIconButton {...props} ref={ref} icon={<Icon variant={icon} />} />
    );
  }
);
